<template>
    <svg :width="data.width" :height="data.height">
        <rect :width="data.width" :height="data.height" opacity="0"></rect>
        <text :text-anchor="align(data.style)" dominant-baseline="text-before-edge"
              :x="x(data.style)" y="0"
              line-height="1"
              :fill="data.style&&data.style.color||'#000000'"
              :font-family="data.style&&data.style.fontFamily"
              :font-size="data.style&&data.style.fontSize||14"
        >{{data.content}}</text>
    </svg>
</template>

<script>
	export default {
		mixins: [],
		props: {
			data: {}
		},
		mounted() {
		},
		methods:{
			align(style){
				if(!style.align||style.align === 'left'){
					return 'start'
                }else if(style.align === 'center'){
					return 'middle'
                }else{
					return 'end'
                }
            },
			x(style){
				if(!style.align||style.align === 'left'){
					return '0'
				}else if(style.align === 'center'){
					return '50%'
				}else{
					return '100%'
				}
			}
        }
	}
</script>
